import { render } from "./ConfirmPageBlock.vue?vue&type=template&id=0db48dca&scoped=true"
import script from "./ConfirmPageBlock.vue?vue&type=script&lang=js"
export * from "./ConfirmPageBlock.vue?vue&type=script&lang=js"

import "./ConfirmPageBlock.vue?vue&type=style&index=0&id=0db48dca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db48dca"]])

export default __exports__